import React from 'react';
import { Modal, Form, Input, Button } from 'antd';
import { contentRsg,materialConRsg } from '@/utils/common/constants';
import BaseComponent from 'components/BaseComponent';
import 'components/Modal/modal.less';
import InputForm from 'components/Form/InputForm';
const FormItem = Form.Item;
const { TextArea } = Input;

/** 编辑、新建直播源网页 */
@Form.create()
export class AddWebComponent extends BaseComponent {

    /* 检查名称 */
    checkName = (row, value, callback) =>{
        const name_max = 50;
        if(value.trim().length > name_max){
            callback(`${window.language['material.maxLength']}${name_max}`);
            return;
        }
        var reg = new RegExp(materialConRsg);
        
        if(reg.test(value.trim())){
            callback(`文件名不能包含以下任何字符: \\ / : * ? " < > |`);      
            return;     
        }

        callback();
    }

    /* 检查URL */
    checkUrl = (row, value, callback) =>{
        if (!value || value.trim().length === 0) {
            callback('');
            return;
        }
        
        const name_max = 100;
        if(value.trim().length > name_max){
            callback(`${window.language['material.maxLength']}${name_max}`);
            return;
        }

        if(!/^((ht|f)tps?):\/\/[\w\-]+(\.[\w\-]+)+([\w\-\.,@?^=%&:\/~\+#]*[\w\-\@?^=%&\/~\+#])?$/.test(value.trim())) {
            callback(window.language['dynamicText.tip.urlIllegal']);      
            return;     
        }

        callback();
    }

    render() {
        const { liveTitle: { type, title }, visible, liveData, hideAddLiveHandler, addLiveHandler, form } = this.props;
        const { getFieldDecorator } = form;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 4 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 18 },
            },
        };
        if (!type) {
            return null;
        }
        let newData = {};
        let readOnlyStyle = {};
        let btnMsg = window.language['common.ok'];
        // 编辑
        if (type === '1' || type === '2') {
            if (!liveData) {
                return null;
            }
            if (!liveData.id) {
                return null;
            }
            newData = liveData;
            if (type === '2') {
                readOnlyStyle.readOnly = true;
                btnMsg = window.language['common.close'];
            }
        }
        
        return (
            visible && 
            <Modal
            visible={visible}
            title={title}
            maskClosable={false}
            onCancel={hideAddLiveHandler}
            width={600}
            footer={null}
            className="material-live-model show-modal-head material-model-style"
            >
                <div className="material-all-body">
                    <div className="live-body">
                        <Form>
                            <FormItem {...formItemLayout} style={{ marginBottom:0 }}>
                                {getFieldDecorator('id', {
                                    initialValue: newData.id ? newData.id : '',
                                })(
                                    <Input type="hidden" />
                                )}
                            </FormItem>
                            <FormItem label={window.language['common.name']} className="material-form-top" {...formItemLayout}>
                                {InputForm({
                                    form,
                                    type: 'input',
                                    name: 'name',
                                    title: window.language['material.columns.name'],
                                    initialValue: newData.name ? newData.name : '',
                                    style: {width: 430},
                                    className: 'ant-input-round',
                                    placeholder: window.language['common.inputContent'],
                                    maxLength: '50',
                                    autoComplete: 'off',
                                    rules: [{
                                        required: true,
                                        message: window.language['common.inputContent']
                                    }, {
                                        validator: this.checkName
                                    }],
                                    ...readOnlyStyle
                                })}
                            </FormItem>
                            <FormItem label={window.language['live.url']} {...formItemLayout}>
                                {InputForm({
                                    form,
                                    type: 'input',
                                    name: 'url',
                                    title: window.language['live.url'],
                                    initialValue: newData.url ? newData.url : '',
                                    style: {width: 430},
                                    className: 'ant-input-round',
                                    placeholder: window.language['live.enterUrl'],
                                    maxLength: '100',
                                    autoComplete: 'off',
                                    rules: [{
                                        required: true,
                                        message: window.language['live.enterUrl']
                                    }, {
                                        validator: this.checkUrl
                                    }],
                                    ...readOnlyStyle
                                })}
                            </FormItem>
                            <FormItem label={window.language['material.columns.remark']} {...formItemLayout}>
                                {InputForm({
                                    form,
                                    type: 'textarea',
                                    name: 'remark',
                                    title: window.language['material.columns.remark'],
                                    initialValue: newData.remark ? newData.remark : '',
                                    style: { height: 130, resize: "none", borderRadius: '4px' },
                                    className: 'ant-input-round',
                                    placeholder: window.language['common.inputRemarkContent'].replace("{1}", 200),
                                    maxLength: '200',
                                    autoComplete: 'off',
                                    rules: [{
                                        validator: this.checkRemark
                                    }],
                                    ...readOnlyStyle
                                })}
                            </FormItem>
                        </Form>
                    </div>
                    <div className="material-foot">
                        <Button type="primary" onClick={(e) => { addLiveHandler(e) }}>{btnMsg}</Button>             
                    </div>
                </div>
            </Modal>
        )
    }
}




// WEBPACK FOOTER //
// ./src/routes/Material/Util/components/addWebComponent.js